<div [formGroup]="form">
  <div class="section-container" id="complementar">
    <div class="section-title">
      <mat-icon>list</mat-icon>
      <span>Dados Complementares</span>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        @if (listaCategoria) {
          <app-select-pesquisavel
            label="Categoria"
            [offlineList]="listaCategoria"
            [control]="idCategoriaControl"
            idField="id"
            nameField="descricao"
            placeholder="Selecione...">
          </app-select-pesquisavel>
        }
      </div>
      <!-- <div class="col-12 col-md-6">
      @if(listaTabelaMedida){
        <app-select-pesquisavel label="Tabela de Medidas" [offlineList]="listaTabelaMedida"
          [control]="idTableaMedidaControl" idField='id' nameField='descricao' placeholder="Selecione...">
        </app-select-pesquisavel>
      }
    </div> -->
      <div class="col-12 col-md-6">
        @if (listaMarca) {
          <app-select-pesquisavel
            label="Marca"
            [offlineList]="listaMarca"
            [control]="idMarcaControl"
            idField="id"
            nameField="descricao"
            placeholder="Selecione...">
          </app-select-pesquisavel>
        }
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descrição Complementar</mat-label>
          <textarea matInput formControlName="descricaoComplementar" rows="3"></textarea>
        </mat-form-field>
      </div>
    </div>
    <!-- Attachments FormArray -->

    <h4 class="subsection-title">Anexos</h4>
    <div
      class="upload-container"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <input type="file" #fileInput multiple (change)="onFileSelected($event)" style="display: none" />

      <div class="upload-dropzone" (click)="fileInput.click()">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="upload-text"><strong>Clique para enviar</strong> ou arraste e solte</p>
        <p class="upload-hint">Limitado a 2mb por arquivo (Máximo 10MB Total)</p>
      </div>
    </div>

    <!-- Lista de Arquivos -->
    @if (anexos.length > 0) {
      <div class="file-list mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <p class="mb-0 font-weight-bold">Arquivos Selecionados:</p>
          <button type="button" mat-button (click)="limparAnexos()">
            <mat-icon>delete_sweep</mat-icon> Limpar Todos
          </button>
        </div>
        @for (file of anexos; track file; let i = $index) {
          <div class="file-item">
            <div class="file-info">
              <mat-icon class="file-icon">description</mat-icon>
              <div class="file-details">
                <span class="file-name">{{ file.nomeArquivo }}</span>
                <span class="file-size">{{ formatBytes(file.tamanhoBytes) }}</span>
              </div>
            </div>
            <div>
              @if (isImageFile(file)) {
                <mat-slide-toggle
                  class="app-toggle-compact"
                  [checked]="file.isCapa"
                  labelPosition="after"
                  (change)="setCapa(i, $event)"
                  >Capa</mat-slide-toggle
                >
              }
              <button
                mat-icon-button
                type="button"
                (click)="downloadAnexo(i)"
                matTooltip="Download arquivo"
                class="close-icon">
                <mat-icon>download</mat-icon>
              </button>
              <button
                mat-icon-button
                type="button"
                (click)="removeAnexo(i)"
                matTooltip="Remover arquivo"
                class="close-icon">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
